import clsx from 'clsx'
import React from 'react'

type DrawerProps = {
    id?: string
    isOpen?: boolean
    isPinned?: boolean
    isHovering?: boolean
    openWidth: number
    closedWidth: number
    onClose?: () => void
    variant: 'permanent' | 'persistent' | 'temporary'
    position?: 'left' | 'right' | 'top' | 'bottom' // Position of the drawer
    children: React.ReactNode
    className?: string // Optional additional styles
    paperClassName?: string
}

export const Drawer: React.FC<DrawerProps> = ({
    id,
    isOpen,
    isPinned = false,
    isHovering,
    onClose,
    openWidth,
    closedWidth,
    position = 'left',
    children,
    variant = 'temporary', // todo
    className,
    paperClassName,
}) => {
    const positionClasses = {
        left: 'left-0 top-0 h-full w-64',
        right: 'right-0 top-0 h-full w-64',
        top: 'top-0 left-0 w-full h-64',
        bottom: 'bottom-0 left-0 w-full h-64',
    }
    return (
        <div
            id={id}
            style={{ width: isOpen ? openWidth : closedWidth, zIndex: 400 }}
            className={clsx(
                'fixed z-100 top-0 drawer bg-white dark:bg-base-100 shadow-lg transition-all duration-300 transform flex flex-col',
                'dark:border dark:border-gray-600',
                isOpen ? 'overflow-visible' : 'overflow-hidden',
                // 'z-50 transform bg-white shadow-lg transition-transform',
                // isOpen ? 'translate-x-0' : '-translate-x-full',
                // isOpen ? 'translate-x-0' : '-translate-x-full',
                positionClasses[position],
                className
            )}
        >
            {/* <div></div> */}
            {/* <button
                onClick={onClose}
                className="absolute top-2 right-2 btn btn-sm btn-circle"
            >
                ✕
            </button> */}
            {/* <input id="my-drawer-2" type="checkbox" className="drawer-toggle h-0 w-0" /> */}
            {/* <div className="drawer-content flex flex-col items-center justify-center">
                <label htmlFor="my-drawer-2" className="btn btn-primary drawer-button lg:hidden">
                    Open drawer
                </label>
            </div>  */}
            {/* <div className="drawer-side flex flex-col h-full" style={{ width: openWidth }}> */}
                {/* <label htmlFor="my-drawer-2" aria-label="close sidebar" className="drawer-overlay"></label>  */}
                {/* <ul className="menu p-4 w-80 min-h-full bg-base-200 text-base-content"> */}
                {/* Sidebar content here */}
                {children}
                {/* </ul> */}
            
            {/* </div> */}
                        
            {/* <div 
                className={clsx("p-0 h-full", paperClassName)}
                style={{ width: isOpen || isHovering ? 200 : 46 }}
            >{children}</div> */}
        </div>
    )
}